import * as React from 'react';
export const HideIcon = ({ size, ...props }) => (
    <svg
        width={size || '1rem'}
        height={size || '1rem'}
        stroke='currentColor'
        fill={props.fill ?? 'currentColor'}
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        viewBox='0 0 59.2 59.2'
        xmlSpace='preserve'
        name='hide-icon'
        {...props}
    >
        <g>
            <path d='M51.062,21.841c-2.1-2.1-4.454-3.851-6.99-5.235l9.549-9.549c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0 L42.186,15.663c-3.93-1.8-8.233-2.753-12.685-2.753c-8.145,0-15.802,3.171-21.561,8.931L0,29.781l8.138,8.138 c2.023,2.023,4.284,3.719,6.714,5.078l-9.145,9.145c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293 s0.512-0.098,0.707-0.293l9.593-9.593c4.01,1.889,8.42,2.886,12.984,2.886c8.145,0,15.802-3.171,21.561-8.931l7.941-7.941 L51.062,21.841z M16.321,41.529c-2.461-1.312-4.741-2.996-6.769-5.024l-6.724-6.724l6.527-6.527 c5.381-5.381,12.536-8.345,20.146-8.345c3.903,0,7.683,0.784,11.169,2.27L16.321,41.529z M49.845,36.505 c-5.381,5.381-12.536,8.345-20.146,8.345c-4.015,0-7.9-0.833-11.468-2.402l24.361-24.361c2.57,1.333,4.951,3.062,7.056,5.168 l6.724,6.724L49.845,36.505z' />
            <path d='M29.572,16.85c-7.168,0-13,5.832-13,13c0,2.543,0.745,4.91,2.012,6.916l17.904-17.904 C34.482,17.595,32.115,16.85,29.572,16.85z' />
            <path d='M22.459,40.718c2.046,1.343,4.488,2.131,7.113,2.131c7.168,0,13-5.832,13-13c0-2.625-0.788-5.067-2.131-7.113 L22.459,40.718z' />
        </g>
    </svg>
);
